


















































import { Component, Vue, Watch } from 'vue-property-decorator';
import { FetchResult } from '../../store';

@Component
export default class FooterNav extends Vue {

    private activeTab = '';

    private tabValues = {
        odpReader      : 'OdpReader'      ,
        odpInformation : 'OdpInformation' ,
        settings       : 'Settings'       ,
        help           : 'Help',
    };

    private mounted() {
        this.activateTab(this.$route.path);
    }

    // URLに合わせてアクティブにするタブを変更する
    @Watch('$route.path')
    private onPathChange(newPath: string, oldPath: string) {
        this.activateTab(newPath);
    }

    private activateTab(path: string) {
        switch (path) {
            case '/OdpReader':
                this.activeTab = this.tabValues.odpReader;
                break;
            case '/OdpInformation':
                this.activeTab = this.tabValues.odpInformation;
                break;
            case '/Settings':
                this.activeTab = this.tabValues.settings;
                break;
            case '/Help':
            case '/FAQ':
            case '/Terms':
            case '/About1dService':
            case '/OpenSourceLicense':
                this.activeTab = this.tabValues.help;
                break;
            default:
                this.activeTab = '';
        }
    }

    // ページ遷移処理
    private goOtherPage(path: string) {
        this.$router.push({
            path,
        });
    }

    /**
     * iOSのpeek, popを無効にする
     * 参考サイト( https://qiita.com/katsuya_U/items/bd0b044fd986c94b5da6 )
     */
    private handleMenuForceTouch(e: TouchEvent) {
        if (!e.touches || !e.touches[0]) { return; }

        if (e.touches[0].force > 0.15) {
            e.preventDefault();
        }
    }

    private get isActivateOdpInfomationBtn() {
        return this.$store.state.fetchResult === FetchResult.Success;
    }
}
